export const TIKTOK_MAX_DESCRIPTION_CHARS = 2200;
